/** TanStack Query key factories for student dashboard resources. */
export const STUDENT_DASHBOARD_ROOT = 'student-dashboard' as const;

export function progressAnalyticsQueryKey(opts: {
  membershipKey: string;
  studentKey: string;
  grade: number;
}) {
  return [
    STUDENT_DASHBOARD_ROOT,
    'progress-analytics',
    opts.membershipKey,
    opts.studentKey,
    opts.grade,
  ] as const;
}

export function tutorAnalyticsSummaryQueryKey(opts: {
  membershipKey: string;
  studentKey: string;
  days: number;
}) {
  return [
    STUDENT_DASHBOARD_ROOT,
    'tutor-analytics-summary',
    opts.membershipKey,
    opts.studentKey,
    opts.days,
  ] as const;
}

export function vocabularyJourneyQueryKey(opts: {
  membershipKey: string;
  studentKey: string;
  grade: number;
}) {
  return [
    STUDENT_DASHBOARD_ROOT,
    'vocabulary-journey',
    opts.membershipKey,
    opts.studentKey,
    opts.grade,
  ] as const;
}

export function assignmentDashboardStatsQueryKey(opts: {
  membershipKey: string;
  studentKey: string;
  grade: number | null | undefined;
}) {
  return [
    STUDENT_DASHBOARD_ROOT,
    'assignment-stats',
    opts.membershipKey,
    opts.studentKey,
    opts.grade ?? 'unknown-grade',
  ] as const;
}

export function weeklyStudentDigestQueryKey(opts: {
  membershipKey: string;
  studentKey: string;
  grade: number;
}) {
  return [STUDENT_DASHBOARD_ROOT, 'weekly-digest', opts.membershipKey, opts.studentKey, opts.grade] as const;
}

export function communicationAssignmentsQueryKey(opts: {
  membershipKey: string;
  studentKey: string;
}) {
  return [
    STUDENT_DASHBOARD_ROOT,
    'communication-assignments',
    opts.membershipKey,
    opts.studentKey,
  ] as const;
}

export function communicationStudentProgressQueryKey(opts: {
  membershipKey: string;
  studentKey: string;
}) {
  return [
    STUDENT_DASHBOARD_ROOT,
    'communication-student-progress',
    opts.membershipKey,
    opts.studentKey,
  ] as const;
}
